// extracted by mini-css-extract-plugin
export default {"modal_button":"ModalButton_modal_button__4PxIJ"};